module.exports = __webpack_public_path__ + "media/images/individual-benefit-4-398079fff71be2c55882caf94d275d9f.svg";